import React from "react";
import { renterFAQItems } from "./data";
import RoundedLinkButton from "../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";
import Accordion from "../../../components/Accordion/Accordion";
import SEOTags from "../../../utils/SEOTags";
import { jsonLdSchema } from "./markup";
import Layout from "../../../components/layout/Layout";

const RenterFAQ = () => {
  return (
    <>
      <SEOTags
        title={"För Hyresgästen   "}
        description={"Kostar det något att registrera sig på plattformen?"}
        canonicalUrl={"/fragor-och-svar/hyresgast"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={jsonLdSchema}
      />
      <div className="accordion-wrapper">
        <h1>Hyresgäst på Vakansa</h1>
        <p className="under-title">Vanliga frågor och svar som Hyresgäst om att hitta lokal på Vakansa</p>
        <Accordion items={renterFAQItems} />
        <div className="contact-back-button-wrapper">
          <p className="contact-info">
            För övriga frågor eller funderingar är du välkommen att kontakta oss på e-postadressen:{" "}
            <a href="mailto:info@vakansa.se">info@vakansa.se</a> eller telefon nummer:{" "}
            <a href="tel:+46767065662">Telefon: 076-706 56 62</a>
            <br />
            <br />
          </p>
          <br />
          <RoundedLinkButton label="Tillbaka" size="md" color="white" href="/fragor-och-svar" />
        </div>
      </div>
      <Layout>
        <main className="faq-info-wrapper">
          <h1>Hyresgäst på Vakansa</h1>
          <p className="under-title">Vanliga frågor och svar som Hyresgäst om att hitta lokal på Vakansa</p>
          {renterFAQItems.map((item, index) => (
            <div key={index}>
              <h2>{item.title}</h2>
              <p>{item.content}</p>
            </div>
          ))}
          <br />
          <br />
          <p>
            För övriga frågor eller funderingar är du välkommen att kontakta oss på e-postadressen:{" "}
            <a href="mailto:info@vakansa.se">info@vakansa.se</a> eller telefon nummer:{" "}
            <a href="tel:+46767065662">Telefon: 076-706 56 62</a>
            <br />
            <br />
          </p>
          <br />
          <RoundedLinkButton label="Tillbaka" size="md" color="white" href="/fragor-och-svar" />
        </main>
      </Layout>
    </>
  );
};

export default RenterFAQ;
